import { Box } from '@mui/material'
import UseTranslation from '../../../../hooks/UseTranslation'
import TitleWithIcon from '../../../../components/Cards/helpers/TitleWithIcon'
import TitleWithInfo from '../../../../components/Cards/helpers/TitleWithInfo'
import { getActionText, getIcon, getSystemText } from '../helper'
import AttachmentDownloader from '../../../../components/Cards/helpers/AttachmentDownloader'

const HistoryItem = ({ history, isSystem }) => {
  if (!history) return null

  const { t } = UseTranslation()

  return (
    <Box>
      <Box sx={styles.historyContent}>
        <TitleWithIcon
          title={isSystem
            ? getSystemText(history, t) : getActionText(history, t, styles)}
          icon={getIcon(history, isSystem)}
          customStyle={styles.actionItem}
        />
      </Box>

      {!isSystem && history?.comment && (
        <TitleWithInfo
          title={t?.Comment}
          info={history?.comment}
          customStyle={styles.collapseInfo}
        />
      )}
          {!isSystem && history?.attachment_group_id && (
      <TitleWithInfo
        title={`${t?.Attachments}`}
        info={(
          <AttachmentDownloader
            attachments={history?.attachment_group_id}
          />
              )}
        customStyle={styles.collapseInfo}
      />
          )}
    </Box>
  )
}

const styles = {
  employeeName: {
    fontWeight: 'bold',
  },
  actionItem: {
    display: 'flex',
    alignItems: 'center',
    margin: { xs: '0px', sm: '0px 0px 0px 20px' },
    '& svg': {
      width: { xs: '15px', sm: '25px' },
      height: { xs: '15px', sm: '25px' },
    },
    '& span': {
      fontSize: { xs: '14px', sm: '16px' },
      fontFamily: 'Avenir',
      marginLeft: '5px',
    },
  },
  collapseInfo: {
    display: 'flex',
    alignItems: 'center',
    margin: { xs: '18px 0px', sm: '18px 0px 10px 118px' },
    h5: {
      margin: '0px',
      width: '100%',
      maxWidth: { xs: '70px', sm: 'content-fit' },
      fontWeight: 350,
      fontSize: { xs: '12px', sm: '14px' },
      lineHeight: { xs: '22px', sm: '27.9px' },
      color: 'grey.500',
    },
    h6: {
      width: '100%',
      maxWidth: { xs: '100%', sm: '900px' },
      marginLeft: '61px',
      textAlign: 'left',
      fontWeight: 350,
      fontSize: { xs: '12px', sm: '14px' },
      lineHeight: '27.9px',
      overflowWrap: 'break-word',
    },
  },

}
export default HistoryItem
